import { useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useLocation, Link } from 'react-router-dom'
import { TopNavigationInvestor } from '~/@biz_investor/navigation-top/TopNavigationInvestor'
import { TopNavigationOwner } from '~/@biz_owner/navigation-top/TopNavigationOwner'
import { FaqCard } from './FaqCard'
import { FaqModal } from './FaqModal'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'

const faqInvestor = [
  {
    title: 'Aký je minimálny investičný vklad?',
    text: 'Povinný mesačný vklad: od 25 €. Nepovinný jednorazový vklad: od 300 €. Čím dlhšie investujete, tým viac vaše peniaze zarábajú. Horný limit nie je stanovený.',
  },
  {
    title: 'Aký vysoký výnos môžem očakávať?',
    text: 'Očakávaný výnos je 7,18 % ročne so zloženým mesačným úročením, ak investujete na minimálne 15 rokov. Ak sa rozhodnete vybrať peniaze skôr, výnos sa upraví na 3,59 % ročne. Vaša investícia však poráža infláciu za každých okolností.',
  },
  {
    title: 'Ako je zabezpečená moja investícia?',
    text: 'Každá investícia je krytá reálnou nehnuteľnosťou. Zároveň automaticky prispievate do rezervného fondu (1 % ročne), ktorý slúži na pokrytie nepredvídaných situácií.',
  },
  {
    title: 'Môžem svoje investované peniaze kedykoľvek vybrať?',
    text: 'Po 15 rokoch môžete vybrať istinu aj celý výnos – 7,18 % ročne zloženého úročenia. Ak sa rozhodnete ukončiť investíciu skôr, vyberiete istinu s výnosom 3,59 % ročne zloženého úročenia. Predčasný výber je možný kedykoľvek – funguje ako bezpečný plán B.',
  },
  {
    title: 'Sú s investíciou spojené poplatky?',
    text: 'Investor získava výnos presne taký, aký je vopred uvedený na platforme Bonaship. Výška výnosu je transparentná a nemení sa počas trvania investície. Po ukončení investície uhrádza senior jednorazový poplatok +1 %, ktorý sa používa ako príspevok do rezervného fondu.',
  },
  {
    title: 'Čo ak jeden mesiac nepošlem investíciu?',
    text: 'Ak dočasne pozastavíte svoje mesačné investície, neplatíte žiadne pokuty. Počas tohto obdobia vám len nebudú pripisované úroky. Zhodnocovanie sa obnoví hneď, ako začnete znova investovať.',
  },
  {
    title: 'Môžem zvýšiť alebo znížiť svoj mesačný príspevok?',
    text: 'Zvýšiť alebo znížiť mesačný príspevok môžete podpísaním novej zmluvy. Zvýšenie alebo níženie mesačnej investície v aktualnej zmluve zatiaľ nie je možné.',
  },
  {
    title: 'Môžem pridať jednorázový vklad neskôr?',
    text: 'Po počiatočnej investícii už nie je možné pridávať ďalšie jednorazové vklady k tej istej zmluve. Investičné podmienky zostávajú rovnaké počas celého obdobia – presne tak, ako si ich nastavíte na začiatku.',
  },
  {
    title: 'Ako môžem sledovať vývoj mojej investície?',
    text: 'Vo svojom online účte na platforme Bonaship máte prístup k investíciám kedykoľvek. Sledujete aktuálny stav, históriu aj všetky dokumenty – jednoducho, prehľadne a 24/7.',
  },
  {
    title: 'Je investícia vhodná ako dôchodkové sporenie?',
    text: 'Áno, 15 a viac rokov je ideálny horizont na budovanie druhého dôchodku. S fixným výnosom, zloženým úročením a investíciou krytou nehnuteľnosťami máte istotu, že vaše peniaze budujú budúcnosť.',
  },
]

const faqOwner = [
  {
    title: 'Aká vysoká bude moja mesačná renta?',
    text: 'Výška vášho Druhého dôchodku závisí od viacerých faktorov. Vášho veku, hodnoty nehnuteľnosti a zvolenej dĺžky obdobia vyplácania. Zavolajte nám alebo napíšte a my vám radi a rýchlo presnú sumu vypočítame.',
  },
  {
    title: 'Budem aj naďalej vlastníkom mojej nehnuteľnosti?',
    text: 'Áno, budete. Celý čas zostanete jediným vlastníkom svojej nehnuteľnosti.',
  },
  {
    title: 'Ako dlho môžem v nehnuteľnosti bývať?',
    text: 'Garantujeme vám právo zostať bývať vo svojej nehnuteľnosti tak dlho, ako budete chcieť - teda aj do konca života. Toto právo vám nikdy nevezmeme.',
  },
  {
    title: 'Čo sa stane s mojou nehnuteľnosťou po mojej smrti?',
    text: 'Naším cieľom je zabezpečiť, aby vašim dedičom zostala čo najväčšia hodnota. Preto budú môcť nehnuteľnosť odkúpiť, predať alebo naložiť s ňou inak, podľa vlastného rozhodnutia.',
  },
  {
    title: 'Ako bude Druhý dôchodok splatený?',
    text: 'Splatenie celej sumy vrátane úrokov a nákladov sa odkladá až na obdobie po smrti seniora. V tom momente preberajú zodpovednosť dedičia, ktorí majú lehotu 6 mesiacov na vyriešenie situácie. Dedičia majú dve možnosti: Splatiť kumulovaný dlh z vlastných zdrojov a ponechať si nehnuteľnosť. Predať nehnuteľnosť a z výťažku uhradiť dlh, pričom zvyšok výťažku im zostane. Ak dedičia nesplatia dlh v šesťmesačnej lehote, platforma pristúpi k predaju nehnuteľnosti a z výťažku uspokojí nárok veriteľov.',
  },
  {
    title: 'Akou sadzbou sa Druhý dôchodok úročí?',
    text: 'Úroková sadzba, ktorú platíte, je 8,18 % ročne.',
  },
  {
    title: 'Platím nejaký poplatok za Druhý dôchodok?',
    text: 'S produktom sú spojené dva druhy poplatkov. Jednorazový vstupný poplatok vo výške 3,99 % z celkovej sumy úverového rámca, ktorý neplatíte počas čerpania Druhého dôchodku. Administratívny poplatok 9,99 % vám mesačne strhneme z výšky vyplácaného dôchodku.',
  },
  {
    title: 'Môžem zmluvu o Druhom dôchodku kedykoľvek zrušiť?',
    text: 'Áno, zmluvu môžete ukončiť alebo vyplatiť kedykoľvek bez akýchkoľvek poplatkov alebo sankcií.',
  },
  {
    title: 'Kto sa stará o údržbu nehnuteľnosti?',
    text: 'O údržbu sa ako majiteľ staráte vy sami. Vašou povinnosťou je udržiavať dom či byt v dobrom stave a platiť dane aj poistenie.',
  },
  {
    title: 'Čo ak sme manželia alebo pár?',
    text: 'Ak ste manželia alebo partneri, obaja podpisujete zmluvu a každý z vás má právo dožitia v nehnuteľnosti. To znamená, že aj po smrti jedného z vás môže druhý partner naďalej bývať v nehnuteľnosti až do konca svojho života. Veková hranica 65 rokov sa počíta podľa mladšieho z vás.',
  },
  {
    title: 'Čo ak cena mojej nehnuteľnosti klesne?',
    text: 'Nemusíte sa báť. Prípadný pokles ceny nehnuteľnosti vás počas života nijako neovplyvní. Nemusíte podnikať žiadne kroky ani znášať dodatočné náklady. Toto riziko je kryté nižším počiatočným pomerom úveru k hodnote nehnuteľnosti (LTV) a tiež rezervným fondom, do ktorého smeruje 1% z ročného úroku.',
  },
]

export const FaqPage = () => {
  const { user } = useCurrentUserData()
  const location = useLocation()

  const [modal, setModal] = useState({ isOpen: false, title: '', text: '' })

  const isInvestorRoute = location.pathname.includes('/investor/')
  const isOwnerRoute = location.pathname.includes('/vlastnik/')

  const faqQuestions = isInvestorRoute ? faqInvestor : faqOwner

  const closeModal = () => setModal({ isOpen: false, title: '', text: '' })

  return (
    <Stack className="min-h-screen bg-zBlack200">
      {isInvestorRoute && <TopNavigationInvestor user={user} />}
      {isOwnerRoute && <TopNavigationOwner user={user} />}

      <Stack className="w-full max-w-[768px] self-center gap-3.5 px-6 pt-6 pb-28">
        <Typography className="text-xl font-bold text-zWhite200">
          FAQ
        </Typography>

        <Stack className="gap-3">
          {faqQuestions.map((item) => (
            <FaqCard
              key={item.title}
              text={item.title}
              onClick={() =>
                setModal({ isOpen: true, title: item.title, text: item.text })
              }
            />
          ))}
        </Stack>

        <Stack className="items-center gap-6 mt-12">
          <Typography className="text-3d font-medium text-zWhite200">
            Nenašli ste odpoveď na vašu otázku?
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to={
              isInvestorRoute
                ? '/investor/help-center'
                : '/vlastnik/help-center'
            }
            className="
              h-14 px-5 bg-zWhite200
              text-3d font-medium text-zBlack200
            ">
            Kontaktovať podporu
          </Button>
        </Stack>
      </Stack>

      <FaqModal
        isOpen={modal.isOpen}
        handleClose={closeModal}
        title={modal.title}
        text={modal.text}
        faqQuestions={faqQuestions}
        setModal={setModal}
      />
    </Stack>
  )
}
